// Generated by scripts/experience/generate-program-route-policies.mjs. Do not edit.
export const GENERATED_PROGRAM_ROUTE_POLICY_CONTRACT = {
  schemaVersion: 1,
  kind: 'statura_experience_program_route_policies',
  generatedBy: 'scripts/experience/generate-program-route-policies.mjs',
  sourceRegistry: 'packages/experience-contract/generated/experience-registry.json',
  sourceRegistrySha256: '26de20e191d87175cfdd1d7d6ee58fd2f2557453cad81f0e4900edf0972a4867',
  sourceInventorySha256: 'f10adf7d6855acdcb642bc7800d92c5671c1af975fb12458be566201fb5b3c78',
  sourceOverrides: 'packages/experience-contract/src/program-route-overrides.json',
  sourceOverridesSha256: '5d6e695b84a7e3f27ce0972757eb7a06255beea71938c18b0b8201c2b372e736',
  policies: {
    web: [
      {
        route: '/',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/page.tsx'],
      },
      {
        route: '/.well-known/apple-app-site-association',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/.well-known/apple-app-site-association/route.ts'],
      },
      {
        route: '/access/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/access/[variant]/page.tsx'],
      },
      {
        route: '/account-deletions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/account-deletions/page.tsx'],
      },
      {
        route: '/activity',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/activity/page.tsx'],
      },
      {
        route: '/admin/system/agency-providers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/agency-providers/page.tsx'],
      },
      {
        route: '/admin/system/ai-usage',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/ai-usage/page.tsx'],
      },
      {
        route: '/admin/system/employer-oncosts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/employer-oncosts/page.tsx'],
      },
      {
        route: '/admin/system/engine-versions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/engine-versions/page.tsx'],
      },
      {
        route: '/admin/system/experience-lab',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/experience-lab/page.tsx'],
      },
      {
        route: '/admin/system/master-data',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/master-data/page.tsx'],
      },
      {
        route: '/admin/system/mobile-devices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/mobile-devices/page.tsx'],
      },
      {
        route: '/admin/system/mobile-devices/shared-stations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/admin/system/mobile-devices/shared-stations/page.tsx',
        ],
      },
      {
        route: '/admin/system/scim',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/scim/page.tsx'],
      },
      {
        route: '/admin/system/signature-corrections',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/signature-corrections/page.tsx'],
      },
      {
        route: '/admin/system/sso',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/sso/page.tsx'],
      },
      {
        route: '/admin/system/sso/*/setup-instructions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/admin/system/sso/[id]/setup-instructions/page.tsx',
        ],
      },
      {
        route: '/admin/system/tenant-config',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/tenant-config/page.tsx'],
      },
      {
        route: '/admin/system/workflows',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workflows/page.tsx'],
      },
      {
        route: '/admin/system/workflows/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workflows/[id]/page.tsx'],
      },
      {
        route: '/admin/system/workflows/*/edit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workflows/[id]/edit/page.tsx'],
      },
      {
        route: '/admin/system/workflows/*/test',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workflows/[id]/test/page.tsx'],
      },
      {
        route: '/admin/system/workflows/*/versions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workflows/[id]/versions/page.tsx'],
      },
      {
        route: '/admin/system/workforce-audit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/admin/system/workforce-audit/page.tsx'],
      },
      {
        route: '/advance-care-plans',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/advance-care-plans/page.tsx'],
      },
      {
        route: '/advance-care-plans/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/advance-care-plans/[id]/page.tsx'],
      },
      {
        route: '/analytics',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/analytics/page.tsx'],
      },
      {
        route: '/analytics/benchmarking',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/analytics/benchmarking/page.tsx'],
      },
      {
        route: '/analytics/board-pack',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/analytics/board-pack/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/analytics/facilities',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/analytics/facilities/page.tsx'],
      },
      {
        route: '/analytics/facilities/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/analytics/facilities/[id]/page.tsx'],
      },
      {
        route: '/announcements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/announcements/page.tsx'],
      },
      {
        route: '/api/audit/care-minutes/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/audit/care-minutes/[facilityId]/route.ts'],
      },
      {
        route: '/api/auth/diagnostics',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/auth/diagnostics/route.ts'],
      },
      {
        route: '/api/auth/password-login',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/auth/password-login/route.ts'],
      },
      {
        route: '/api/auth/sso/lookup',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/auth/sso/lookup/route.ts'],
      },
      {
        route: '/api/care-plans/*/canonical-copy',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/care-plans/[id]/canonical-copy/route.ts'],
      },
      {
        route: '/api/care-plans/*/printable/audit-print',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/care-plans/[id]/printable/audit-print/route.ts'],
      },
      {
        route: '/api/clients/*/journey/printable/audit-print',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/clients/[id]/journey/printable/audit-print/route.ts'],
      },
      {
        route: '/api/compliance/audit-pack/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/audit-pack/export/route.ts'],
      },
      {
        route: '/api/compliance/calendar/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/calendar/[token]/route.ts'],
      },
      {
        route: '/api/compliance/incidents/*/sirs-notification.json',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/compliance/incidents/[id]/sirs-notification.json/route.ts',
        ],
      },
      {
        route: '/api/compliance/incidents/*/sirs-notification/audit-print',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/compliance/incidents/[id]/sirs-notification/audit-print/route.ts',
        ],
      },
      {
        route: '/api/compliance/incidents/post-create-notify',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/incidents/post-create-notify/route.ts'],
      },
      {
        route: '/api/compliance/packs/*/download',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/packs/[versionId]/download/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/dashboard',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/dashboard/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/investigators',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/investigators/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/recipients',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/recipients/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/recipients/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/recipients/[id]/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/reports/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/reports/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/compliance/whistleblower/reports/[id]/route.ts'],
      },
      {
        route: '/api/compliance/whistleblower/reports/*/messages',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/compliance/whistleblower/reports/[id]/messages/route.ts',
        ],
      },
      {
        route: '/api/cron/ahpra-verification-sync',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/ahpra-verification-sync/route.ts'],
      },
      {
        route: '/api/cron/award-rate-coverage',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/award-rate-coverage/route.ts'],
      },
      {
        route: '/api/cron/care-minute-recompute',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/care-minute-recompute/route.ts'],
      },
      {
        route: '/api/cron/care-plan-reviews',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/care-plan-reviews/route.ts'],
      },
      {
        route: '/api/cron/ceis-reissue',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/ceis-reissue/route.ts'],
      },
      {
        route: '/api/cron/cert-expiry-alerts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/cert-expiry-alerts/route.ts'],
      },
      {
        route: '/api/cron/compliance-watcher',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/compliance-watcher/route.ts'],
      },
      {
        route: '/api/cron/contractor-compliance-expiry',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/contractor-compliance-expiry/route.ts'],
      },
      {
        route: '/api/cron/credential-recollection',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/credential-recollection/route.ts'],
      },
      {
        route: '/api/cron/dispatch-dashboard-reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/dispatch-dashboard-reports/route.ts'],
      },
      {
        route: '/api/cron/dispatch-report-subscriptions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/dispatch-report-subscriptions/route.ts'],
      },
      {
        route: '/api/cron/document-expiry-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/document-expiry-sweep/route.ts'],
      },
      {
        route: '/api/cron/enforce-deadlines',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/enforce-deadlines/route.ts'],
      },
      {
        route: '/api/cron/escalate-stranded-capture-sla',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/escalate-stranded-capture-sla/route.ts'],
      },
      {
        route: '/api/cron/hi-demographic-audit-recovery',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/hi-demographic-audit-recovery/route.ts'],
      },
      {
        route: '/api/cron/hypercare-alert',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/hypercare-alert/route.ts'],
      },
      {
        route: '/api/cron/hypercare-digest',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/hypercare-digest/route.ts'],
      },
      {
        route: '/api/cron/invoice-overdue-stamp',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/invoice-overdue-stamp/route.ts'],
      },
      {
        route: '/api/cron/leave-loading-anomaly',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/leave-loading-anomaly/route.ts'],
      },
      {
        route: '/api/cron/ndis-worker-screening-sync',
        classification: 'OTHER_PROGRAM',
        firewallFamilies: ['OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/ndis-worker-screening-sync/route.ts'],
      },
      {
        route: '/api/cron/notification-digest',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/notification-digest/route.ts'],
      },
      {
        route: '/api/cron/notification-heartbeat',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/notification-heartbeat/route.ts'],
      },
      {
        route: '/api/cron/process-account-deletion-requests',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/process-account-deletion-requests/route.ts'],
      },
      {
        route: '/api/cron/process-deadline-notifications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/process-deadline-notifications/route.ts'],
      },
      {
        route: '/api/cron/process-escalation-timers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/process-escalation-timers/route.ts'],
      },
      {
        route: '/api/cron/process-notifications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/process-notifications/route.ts'],
      },
      {
        route: '/api/cron/refresh-tenant-module-entitlements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/refresh-tenant-module-entitlements/route.ts'],
      },
      {
        route: '/api/cron/roster-attendance-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/roster-attendance-sweep/route.ts'],
      },
      {
        route: '/api/cron/roster-optimiser',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/roster-optimiser/route.ts'],
      },
      {
        route: '/api/cron/sah-funding-expiry-sweep',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/sah-funding-expiry-sweep/route.ts'],
      },
      {
        route: '/api/cron/sah-monthly-statements',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/sah-monthly-statements/route.ts'],
      },
      {
        route: '/api/cron/sah-quarterly-rollover',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/sah-quarterly-rollover/route.ts'],
      },
      {
        route: '/api/cron/screening-expiry',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/screening-expiry/route.ts'],
      },
      {
        route: '/api/cron/screening-expiry-events',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/screening-expiry-events/route.ts'],
      },
      {
        route: '/api/cron/sentry-alert-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/sentry-alert-sweep/route.ts'],
      },
      {
        route: '/api/cron/services-australia-proda-lifecycle',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/services-australia-proda-lifecycle/route.ts'],
      },
      {
        route: '/api/cron/signed-document-artifact-recovery',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/signed-document-artifact-recovery/route.ts'],
      },
      {
        route: '/api/cron/station-lifecycle',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/station-lifecycle/route.ts'],
      },
      {
        route: '/api/cron/station-management',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/station-management/route.ts'],
      },
      {
        route: '/api/cron/support-assistant-maintenance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/support-assistant-maintenance/route.ts'],
      },
      {
        route: '/api/cron/support-ticket-operator-outbox',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/support-ticket-operator-outbox/route.ts'],
      },
      {
        route: '/api/cron/system-health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/system-health/route.ts'],
      },
      {
        route: '/api/cron/telehealth-recording-ingestion',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/telehealth-recording-ingestion/route.ts'],
      },
      {
        route: '/api/cron/third-party-referrals-chase',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/third-party-referrals-chase/route.ts'],
      },
      {
        route: '/api/cron/trial-lifecycle',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/trial-lifecycle/route.ts'],
      },
      {
        route: '/api/cron/worker-continuity-refresh',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/worker-continuity-refresh/route.ts'],
      },
      {
        route: '/api/cron/workforce-projection-worker',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/workforce-projection-worker/route.ts'],
      },
      {
        route: '/api/cron/wtc-evidence-shadow-drain',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/wtc-evidence-shadow-drain/route.ts'],
      },
      {
        route: '/api/cron/xero-ar-ageing-parity',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-ar-ageing-parity/route.ts'],
      },
      {
        route: '/api/cron/xero-ar-credit-note-push',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-ar-credit-note-push/route.ts'],
      },
      {
        route: '/api/cron/xero-ar-payment-sync',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-ar-payment-sync/route.ts'],
      },
      {
        route: '/api/cron/xero-ar-push',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-ar-push/route.ts'],
      },
      {
        route: '/api/cron/xero-ar-recon-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-ar-recon-sweep/route.ts'],
      },
      {
        route: '/api/cron/xero-connection-health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-connection-health/route.ts'],
      },
      {
        route: '/api/cron/xero-leave-balance-sync',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-leave-balance-sync/route.ts'],
      },
      {
        route: '/api/cron/xero-master-data-sync',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-master-data-sync/route.ts'],
      },
      {
        route: '/api/cron/xero-payrun-reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-payrun-reconciliation/route.ts'],
      },
      {
        route: '/api/cron/xero-rate-drift-check',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-rate-drift-check/route.ts'],
      },
      {
        route: '/api/cron/xero-refresh-tokens',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/cron/xero-refresh-tokens/route.ts'],
      },
      {
        route: '/api/customer-legal',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/customer-legal/route.ts'],
      },
      {
        route: '/api/demo-documents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/demo-documents/[slug]/route.ts'],
      },
      {
        route: '/api/feedback/public',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/feedback/public/route.ts'],
      },
      {
        route: '/api/finance/invoices/*/fallback-csv',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/finance/invoices/[id]/fallback-csv/route.ts'],
      },
      {
        route: '/api/finance/statements/rollup',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/finance/statements/rollup/route.ts'],
      },
      {
        route: '/api/health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/health/route.ts'],
      },
      {
        route: '/api/help/assistant/offer',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/help/assistant/offer/route.ts'],
      },
      {
        route: '/api/help/assistant/outcome',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/help/assistant/outcome/route.ts'],
      },
      {
        route: '/api/help/assistant/ticket',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/help/assistant/ticket/route.ts'],
      },
      {
        route: '/api/help/assistant/ticket/status',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/help/assistant/ticket/status/route.ts'],
      },
      {
        route: '/api/help/chat',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/help/chat/route.ts'],
      },
      {
        route: '/api/integrations/fit2work/test-webhook',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/integrations/fit2work/test-webhook/route.ts'],
      },
      {
        route: '/api/integrations/services-australia/aged-care-rest/evidence.csv',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/integrations/services-australia/aged-care-rest/evidence.csv/route.ts',
        ],
      },
      {
        route: '/api/integrations/services-australia/aged-care-rest/payment-statement',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/integrations/services-australia/aged-care-rest/payment-statement/route.ts',
        ],
      },
      {
        route: '/api/integrations/services-australia/noi/finance-execution',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/integrations/services-australia/noi/finance-execution/route.ts',
        ],
      },
      {
        route: '/api/integrations/services-australia/proda/hosted-rotation',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/integrations/services-australia/proda/hosted-rotation/route.ts',
        ],
      },
      {
        route: '/api/integrations/services-australia/rac-opt-in/clients/*/attachments/*/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/integrations/services-australia/rac-opt-in/clients/[id]/attachments/[eventId]/[attachmentId]/route.ts',
        ],
      },
      {
        route: '/api/integrations/xero/status',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/integrations/xero/status/route.ts'],
      },
      {
        route: '/api/internal/clinical/deterioration-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/clinical/deterioration-sweep/route.ts'],
      },
      {
        route: '/api/internal/clinical/pathway-sla-sweep',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/clinical/pathway-sla-sweep/route.ts'],
      },
      {
        route: '/api/internal/clinical/sweeps',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/clinical/sweeps/route.ts'],
      },
      {
        route: '/api/internal/cron-health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/cron-health/route.ts'],
      },
      {
        route: '/api/internal/notification-dispatch',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/notification-dispatch/route.ts'],
      },
      {
        route: '/api/internal/notification-source-recovery',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/notification-source-recovery/route.ts'],
      },
      {
        route: '/api/internal/people/legacy-route-usage',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/internal/people/legacy-route-usage/route.ts'],
      },
      {
        route: '/api/leave/balance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/leave/balance/route.ts'],
      },
      {
        route: '/api/mobile/app-version-policy',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/app-version-policy/route.ts'],
      },
      {
        route: '/api/mobile/auth/password-reset/request',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/auth/password-reset/request/route.ts'],
      },
      {
        route: '/api/mobile/auth/password-reset/update',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/auth/password-reset/update/route.ts'],
      },
      {
        route: '/api/mobile/auth/password-reset/verify',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/auth/password-reset/verify/route.ts'],
      },
      {
        route: '/api/mobile/leave/requests',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/leave/requests/route.ts'],
      },
      {
        route: '/api/mobile/leave/requests/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/leave/requests/[requestId]/route.ts'],
      },
      {
        route: '/api/mobile/leave/requests/*/evidence',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/leave/requests/[requestId]/evidence/route.ts'],
      },
      {
        route: '/api/mobile/leave/self-service-types',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/leave/self-service-types/route.ts'],
      },
      {
        route: '/api/mobile/station/attendance/auth',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/attendance/auth/route.ts'],
      },
      {
        route: '/api/mobile/station/attendance/confirm',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/attendance/confirm/route.ts'],
      },
      {
        route: '/api/mobile/station/attendance/context',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/attendance/context/route.ts'],
      },
      {
        route: '/api/mobile/station/clinical/command',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/clinical/command/route.ts'],
      },
      {
        route: '/api/mobile/station/clinical/recovery',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/clinical/recovery/route.ts'],
      },
      {
        route: '/api/mobile/station/device/command',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/device/command/route.ts'],
      },
      {
        route: '/api/mobile/station/enrolment/complete',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/enrolment/complete/route.ts'],
      },
      {
        route: '/api/mobile/station/management/complete',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/management/complete/route.ts'],
      },
      {
        route: '/api/mobile/station/medication/witness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/medication/witness/route.ts'],
      },
      {
        route: '/api/mobile/station/session/auth',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/session/auth/route.ts'],
      },
      {
        route: '/api/mobile/station/session/control',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/session/control/route.ts'],
      },
      {
        route: '/api/mobile/station/session/phone',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/session/phone/route.ts'],
      },
      {
        route: '/api/mobile/station/session/resume',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/mobile/station/session/resume/route.ts'],
      },
      {
        route: '/api/notifications/acknowledge',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/notifications/acknowledge/route.ts'],
      },
      {
        route: '/api/payroll/agency-invoices/*/csv',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/payroll/agency-invoices/[invoiceId]/csv/route.ts'],
      },
      {
        route: '/api/payroll/agency-invoices/*/printable',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/payroll/agency-invoices/[invoiceId]/printable/route.ts',
        ],
      },
      {
        route: '/api/payroll/pay-runs/*/fallback-csv',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/payroll/pay-runs/[id]/fallback-csv/route.ts'],
      },
      {
        route: '/api/payroll/pay-runs/*/generic-csv-payslip/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/payroll/pay-runs/[id]/generic-csv-payslip/[kind]/route.ts',
        ],
      },
      {
        route: '/api/people/workers/*/screening/*/file',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/people/workers/[staffId]/screening/[evidenceId]/file/route.ts',
        ],
      },
      {
        route: '/api/rac/admissions-occupancy/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/admissions-occupancy/summary/route.ts'],
      },
      {
        route: '/api/rac/clinical-governance/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/clinical-governance/summary/route.ts'],
      },
      {
        route: '/api/rac/facility-operations/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/facility-operations/summary/route.ts'],
      },
      {
        route: '/api/rac/quality-reporting/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/quality-reporting/summary/route.ts'],
      },
      {
        route: '/api/rac/respite-operations/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/respite-operations/summary/route.ts'],
      },
      {
        route: '/api/rac/workforce-operations/summary',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/rac/workforce-operations/summary/route.ts'],
      },
      {
        route: '/api/reports/runs/*/download/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/reports/runs/[id]/download/[format]/route.ts'],
      },
      {
        route: '/api/residential/anacc-worksheet',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/residential/anacc-worksheet/route.ts'],
      },
      {
        route: '/api/roster/dispatch/assignment-candidates',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/roster/dispatch/assignment-candidates/route.ts'],
      },
      {
        route: '/api/roster/dispatch/assignment-candidates/fallback',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/roster/dispatch/assignment-candidates/fallback/route.ts',
        ],
      },
      {
        route: '/api/roster/dispatch/assignment-commands/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/api/roster/dispatch/assignment-commands/[commandKey]/route.ts',
        ],
      },
      {
        route: '/api/roster/dispatch/assignment-readiness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/roster/dispatch/assignment-readiness/route.ts'],
      },
      {
        route: '/api/roster/dispatch/cards',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/roster/dispatch/cards/route.ts'],
      },
      {
        route: '/api/roster/runtime-status',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/roster/runtime-status/route.ts'],
      },
      {
        route: '/api/scim/v2/**',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/scim/v2/[[...path]]/route.ts'],
      },
      {
        route: '/api/training/modules/*/preview-video',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/training/modules/[moduleId]/preview-video/route.ts'],
      },
      {
        route: '/api/translate',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/translate/route.ts'],
      },
      {
        route: '/api/unsubscribe',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/unsubscribe/route.ts'],
      },
      {
        route: '/api/webhooks/resend',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/webhooks/resend/route.ts'],
      },
      {
        route: '/api/webhooks/stripe',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/webhooks/stripe/route.ts'],
      },
      {
        route: '/api/webhooks/twilio/telehealth-recording',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/webhooks/twilio/telehealth-recording/route.ts'],
      },
      {
        route: '/api/whistleblower/follow-up',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/whistleblower/follow-up/route.ts'],
      },
      {
        route: '/api/whistleblower/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/whistleblower/reports/route.ts'],
      },
      {
        route: '/api/workforce/exports/*/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/workforce/exports/[id]/[part]/route.ts'],
      },
      {
        route: '/api/xero/authorize',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/xero/authorize/route.ts'],
      },
      {
        route: '/api/xero/callback',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/xero/callback/route.ts'],
      },
      {
        route: '/api/xero/disconnect',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/api/xero/disconnect/route.ts'],
      },
      {
        route: '/apple-app-site-association',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/apple-app-site-association/route.ts'],
      },
      {
        route: '/assessments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/assessments/page.tsx'],
      },
      {
        route: '/assessments/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/assessments/[id]/page.tsx'],
      },
      {
        route: '/assessments/library',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/assessments/library/page.tsx'],
      },
      {
        route: '/audit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/audit/page.tsx'],
      },
      {
        route: '/audit/evidence/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/audit/evidence/[entityId]/page.tsx'],
      },
      {
        route: '/auth/callback',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/auth/callback/route.ts'],
      },
      {
        route: '/auth/mfa',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/auth/mfa/page.tsx'],
      },
      {
        route: '/auth/mfa/enroll',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/auth/mfa/enroll/page.tsx'],
      },
      {
        route: '/auth/mobile-session',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/auth/mobile-session/page.tsx'],
      },
      {
        route: '/auth/recovery',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/auth/recovery/page.tsx'],
      },
      {
        route: '/auth/signout',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/auth/signout/route.ts'],
      },
      {
        route: '/billing',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/billing/page.tsx'],
      },
      {
        route: '/care-pathways',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-pathways/page.tsx'],
      },
      {
        route: '/care-plans',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/page.tsx'],
      },
      {
        route: '/care-plans/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/[id]/page.tsx'],
      },
      {
        route: '/care-plans/*/compose',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/[id]/compose/page.tsx'],
      },
      {
        route: '/care-plans/*/goals/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/[id]/goals/[goal_id]/page.tsx'],
      },
      {
        route: '/care-plans/*/printable',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/[id]/printable/page.tsx'],
      },
      {
        route: '/care-plans/bulk-replan',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/bulk-replan/page.tsx'],
      },
      {
        route: '/care-plans/configuration',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/configuration/page.tsx'],
      },
      {
        route: '/care-plans/synthesize',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/care-plans/synthesize/page.tsx'],
      },
      {
        route: '/clients',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/page.tsx'],
      },
      {
        route: '/clients/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/page.tsx'],
      },
      {
        route: '/clients/*/assessments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/assessments/page.tsx'],
      },
      {
        route: '/clients/*/care-plans/*/signed-pdf',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clients/[id]/care-plans/[carePlanId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/clients/*/care-plans/service-agreements/*/review',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clients/[id]/care-plans/service-agreements/[agreementId]/review/route.ts',
        ],
      },
      {
        route: '/clients/*/care-plans/service-agreements/*/signed-pdf',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clients/[id]/care-plans/service-agreements/[agreementId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/clients/*/case-notes',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/case-notes/page.tsx'],
      },
      {
        route: '/clients/*/clinical/devices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/clinical/devices/page.tsx'],
      },
      {
        route: '/clients/*/clinical/pathways',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/clinical/pathways/page.tsx'],
      },
      {
        route: '/clients/*/clinical/restorative',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/clinical/restorative/page.tsx'],
      },
      {
        route: '/clients/*/clinical/thresholds',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/clinical/thresholds/page.tsx'],
      },
      {
        route: '/clients/*/clinical/trends',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/clinical/trends/page.tsx'],
      },
      {
        route: '/clients/*/comfort',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/comfort/page.tsx'],
      },
      {
        route: '/clients/*/communications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/communications/page.tsx'],
      },
      {
        route: '/clients/*/consents/*/signed-pdf',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clients/[id]/consents/[consentId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/clients/*/devices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/devices/page.tsx'],
      },
      {
        route: '/clients/*/incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/incidents/page.tsx'],
      },
      {
        route: '/clients/*/journey/printable',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clients/[id]/journey/printable/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/clients/*/medications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/medications/page.tsx'],
      },
      {
        route: '/clients/*/medications/monitoring',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/medications/monitoring/page.tsx'],
      },
      {
        route: '/clients/*/observations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/observations/page.tsx'],
      },
      {
        route: '/clients/*/referrals',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/[id]/referrals/page.tsx'],
      },
      {
        route: '/clients/*/sah/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/clients/batch-validation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/batch-validation/page.tsx'],
      },
      {
        route: '/clients/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clients/new/page.tsx'],
      },
      {
        route: '/clinical',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/page.tsx'],
      },
      {
        route: '/clinical/alerts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/alerts/page.tsx'],
      },
      {
        route: '/clinical/alerts/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/alerts/[id]/page.tsx'],
      },
      {
        route: '/clinical/alerts/suppression',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/alerts/suppression/page.tsx'],
      },
      {
        route: '/clinical/caseload',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/clinical/caseload/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/clinical/delegations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/delegations/page.tsx'],
      },
      {
        route: '/clinical/escalations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/escalations/page.tsx'],
      },
      {
        route: '/clinical/escalations/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/escalations/[id]/page.tsx'],
      },
      {
        route: '/clinical/handovers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/handovers/page.tsx'],
      },
      {
        route: '/clinical/medication-incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/medication-incidents/page.tsx'],
      },
      {
        route: '/clinical/medication-incidents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/medication-incidents/[id]/page.tsx'],
      },
      {
        route: '/clinical/overdue-assessments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/overdue-assessments/page.tsx'],
      },
      {
        route: '/clinical/pathways',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/pathways/page.tsx'],
      },
      {
        route: '/clinical/pathways/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/pathways/[enrolmentId]/page.tsx'],
      },
      {
        route: '/clinical/restorative',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/restorative/page.tsx'],
      },
      {
        route: '/clinical/restorative/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/restorative/[programmeId]/page.tsx'],
      },
      {
        route: '/clinical/wounds/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/clinical/wounds/[id]/page.tsx'],
      },
      {
        route: '/cm-tasks',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/cm-tasks/page.tsx'],
      },
      {
        route: '/cm-tasks/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/cm-tasks/approve',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/cm-tasks/approve/page.tsx'],
      },
      {
        route: '/cm-tasks/new',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/cm-tasks/new/page.tsx'],
      },
      {
        route: '/cm-tasks/unknown',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/cm-tasks/unknown/page.tsx'],
      },
      {
        route: '/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/page.tsx'],
      },
      {
        route: '/compliance/audit-pack/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/audit-pack/export/page.tsx'],
      },
      {
        route: '/compliance/audit-program',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/audit-program/page.tsx'],
      },
      {
        route: '/compliance/audit-program/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/audit-program/[id]/page.tsx'],
      },
      {
        route: '/compliance/audit-program/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/audit-program/new/page.tsx'],
      },
      {
        route: '/compliance/audit-trail',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/audit-trail/page.tsx'],
      },
      {
        route: '/compliance/b2g/audit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/b2g/audit/page.tsx'],
      },
      {
        route: '/compliance/calendar',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/calendar/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/capability-framework',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/capability-framework/page.tsx'],
      },
      {
        route: '/compliance/capability-framework/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/capability-framework/[staffId]/page.tsx',
        ],
      },
      {
        route: '/compliance/clinical-governance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/clinical-governance/page.tsx'],
      },
      {
        route: '/compliance/complaints',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/complaints/page.tsx'],
      },
      {
        route: '/compliance/complaints/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/complaints/[id]/page.tsx'],
      },
      {
        route: '/compliance/complaints/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/complaints/new/page.tsx'],
      },
      {
        route: '/compliance/continuous-improvement',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/continuous-improvement/page.tsx'],
      },
      {
        route: '/compliance/continuous-improvement/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/continuous-improvement/[id]/page.tsx',
        ],
      },
      {
        route: '/compliance/continuous-improvement/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/continuous-improvement/new/page.tsx',
        ],
      },
      {
        route: '/compliance/data-breach',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/data-breach/page.tsx'],
      },
      {
        route: '/compliance/data-breach/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/data-breach/[id]/page.tsx'],
      },
      {
        route: '/compliance/data-breach/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/data-breach/new/page.tsx'],
      },
      {
        route: '/compliance/documents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/documents/page.tsx'],
      },
      {
        route: '/compliance/documents/expiring',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/documents/expiring/page.tsx'],
      },
      {
        route: '/compliance/environmental',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/environmental/page.tsx'],
      },
      {
        route: '/compliance/evidence-packs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/evidence-packs/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/governance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/governance/page.tsx'],
      },
      {
        route: '/compliance/governance/conflicts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/governance/conflicts/page.tsx'],
      },
      {
        route: '/compliance/governance/qcab',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/governance/qcab/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/governance/risk-register',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/governance/risk-register/page.tsx'],
      },
      {
        route: '/compliance/governance/risk-register/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/governance/risk-register/[id]/page.tsx',
        ],
      },
      {
        route: '/compliance/governance/risk-register/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/governance/risk-register/new/page.tsx',
        ],
      },
      {
        route: '/compliance/governance/skills-matrix',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/governance/skills-matrix/page.tsx'],
      },
      {
        route: '/compliance/incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/incidents/page.tsx'],
      },
      {
        route: '/compliance/incidents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/incidents/[id]/page.tsx'],
      },
      {
        route: '/compliance/incidents/*/print',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/incidents/[id]/print/page.tsx'],
      },
      {
        route: '/compliance/incidents/*/sirs-final-report',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/incidents/[id]/sirs-final-report/page.tsx',
        ],
      },
      {
        route: '/compliance/incidents/*/sirs-notification',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/incidents/[id]/sirs-notification/page.tsx',
        ],
      },
      {
        route: '/compliance/incidents/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/incidents/new/page.tsx'],
      },
      {
        route: '/compliance/ipc',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/page.tsx'],
      },
      {
        route: '/compliance/ipc/outbreaks',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/outbreaks/page.tsx'],
      },
      {
        route: '/compliance/ipc/outbreaks/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/outbreaks/new/page.tsx'],
      },
      {
        route: '/compliance/ipc/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/reports/page.tsx'],
      },
      {
        route: '/compliance/ipc/surveillance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/surveillance/page.tsx'],
      },
      {
        route: '/compliance/ipc/surveillance/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ipc/surveillance/new/page.tsx'],
      },
      {
        route: '/compliance/ndis-overlay',
        classification: 'OTHER_PROGRAM',
        firewallFamilies: ['OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/ndis-overlay/page.tsx'],
      },
      {
        route: '/compliance/policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/policies/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/prudential',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/page.tsx'],
      },
      {
        route: '/compliance/prudential/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/compliance/prudential/accommodation-agreements',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/prudential/accommodation-agreements/page.tsx',
        ],
      },
      {
        route: '/compliance/prudential/accommodation-agreements/*/signed-pdf',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/prudential/accommodation-agreements/[agreementId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/compliance/prudential/deposits',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/deposits/page.tsx'],
      },
      {
        route: '/compliance/prudential/deposits/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/deposits/[id]/page.tsx'],
      },
      {
        route: '/compliance/prudential/deposits/new',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/deposits/new/page.tsx'],
      },
      {
        route: '/compliance/prudential/governance',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/governance/page.tsx'],
      },
      {
        route: '/compliance/prudential/liquidity',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/liquidity/page.tsx'],
      },
      {
        route: '/compliance/prudential/permitted-uses',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/permitted-uses/page.tsx'],
      },
      {
        route: '/compliance/prudential/pricing',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/pricing/page.tsx'],
      },
      {
        route: '/compliance/prudential/reports',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/prudential/reports/page.tsx'],
      },
      {
        route: '/compliance/quality-indicators',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/quality-indicators/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/quality/qi-data-entry/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/compliance/quality/qi-data-entry/reporting',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/quality/qi-data-entry/reporting/page.tsx',
        ],
      },
      {
        route: '/compliance/quality/qi-data-entry/submit',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/quality/qi-data-entry/submit/page.tsx',
        ],
      },
      {
        route: '/compliance/record-recovery',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/record-recovery/page.tsx'],
      },
      {
        route: '/compliance/registration',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/registration/page.tsx'],
      },
      {
        route: '/compliance/reporting',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/reporting/page.tsx'],
      },
      {
        route: '/compliance/reporting/dex',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/reporting/dex/page.tsx'],
      },
      {
        route: '/compliance/responsible-persons',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/responsible-persons/page.tsx'],
      },
      {
        route: '/compliance/responsible-persons/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/responsible-persons/[id]/page.tsx'],
      },
      {
        route: '/compliance/responsible-persons/*/edit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/responsible-persons/[id]/edit/page.tsx',
        ],
      },
      {
        route: '/compliance/responsible-persons/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/responsible-persons/new/page.tsx'],
      },
      {
        route: '/compliance/restrictive-practices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/restrictive-practices/page.tsx'],
      },
      {
        route: '/compliance/restrictive-practices/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/restrictive-practices/[id]/page.tsx',
        ],
      },
      {
        route: '/compliance/restrictive-practices/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/restrictive-practices/new/page.tsx'],
      },
      {
        route: '/compliance/rn-coverage',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/rn-coverage/page.tsx'],
      },
      {
        route: '/compliance/rn-coverage/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/compliance/rn-coverage/reporting',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/rn-coverage/reporting/page.tsx'],
      },
      {
        route: '/compliance/sah-evidence',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/sah-evidence/page.tsx'],
      },
      {
        route: '/compliance/sah-evidence/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/compliance/standards',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/standards/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/standards/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/standards/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/standards/tagged-evidence/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/standards/tagged-evidence/export/route.ts',
        ],
      },
      {
        route: '/compliance/star-ratings',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/star-ratings/page.tsx'],
      },
      {
        route: '/compliance/star-ratings/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/star-ratings/[facilityId]/page.tsx'],
      },
      {
        route: '/compliance/star-ratings/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/compliance/star-ratings/methodology',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/star-ratings/methodology/page.tsx'],
      },
      {
        route: '/compliance/validity-rules',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/validity-rules/page.tsx'],
      },
      {
        route: '/compliance/validity-rules/audit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/validity-rules/audit/page.tsx'],
      },
      {
        route: '/compliance/whistleblower',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whistleblower/page.tsx'],
      },
      {
        route: '/compliance/whs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/page.tsx'],
      },
      {
        route: '/compliance/whs/chemicals',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/chemicals/page.tsx'],
      },
      {
        route: '/compliance/whs/drills',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/drills/page.tsx'],
      },
      {
        route: '/compliance/whs/equipment',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/equipment/page.tsx'],
      },
      {
        route: '/compliance/whs/hazards',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/hazards/page.tsx'],
      },
      {
        route: '/compliance/whs/hazards/*/edit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/hazards/[id]/edit/page.tsx'],
      },
      {
        route: '/compliance/whs/hazards/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/hazards/new/page.tsx'],
      },
      {
        route: '/compliance/whs/incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/incidents/page.tsx'],
      },
      {
        route: '/compliance/whs/incidents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/incidents/[id]/page.tsx'],
      },
      {
        route: '/compliance/whs/incidents/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/incidents/new/page.tsx'],
      },
      {
        route: '/compliance/whs/psychosocial',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/whs/psychosocial/page.tsx'],
      },
      {
        route: '/compliance/work',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/work/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/compliance/workforce/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/compliance/workforce/export/route.ts'],
      },
      {
        route: '/compliance/workforce/import',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/compliance/workforce/import/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/contractors',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/page.tsx'],
      },
      {
        route: '/contractors/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/page.tsx'],
      },
      {
        route: '/contractors/*/bank-account',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/bank-account/page.tsx'],
      },
      {
        route: '/contractors/*/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/compliance/page.tsx'],
      },
      {
        route: '/contractors/*/documents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/contractors/[id]/documents/[documentId]/page.tsx',
        ],
      },
      {
        route: '/contractors/*/engagements/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/engagements/new/page.tsx'],
      },
      {
        route: '/contractors/*/evidence/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/evidence/new/page.tsx'],
      },
      {
        route: '/contractors/*/invoices/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/invoices/new/page.tsx'],
      },
      {
        route: '/contractors/*/people',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/people/page.tsx'],
      },
      {
        route: '/contractors/*/services/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/[id]/services/new/page.tsx'],
      },
      {
        route: '/contractors/evidence/queue',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/evidence/queue/page.tsx'],
      },
      {
        route: '/contractors/evidence/queue/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/contractors/evidence/queue/[evidenceId]/page.tsx',
        ],
      },
      {
        route: '/contractors/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/new/page.tsx'],
      },
      {
        route: '/contractors/reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/contractors/reconciliation/page.tsx'],
      },
      {
        route: '/dashboards',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/dashboards/page.tsx'],
      },
      {
        route: '/dashboards/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/dashboards/[...slug]/page.tsx'],
      },
      {
        route: '/dashboards/caseload',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/don-clinical',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/executive',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/facility-ops',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/home-care-ops',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/multi-facility',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/quality',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/risk-correlation',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/dashboards/workforce',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/deliveries',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/deliveries/page.tsx'],
      },
      {
        route: '/email-preview',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/email-preview/page.tsx'],
      },
      {
        route: '/feature-flags',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/feature-flags/page.tsx'],
      },
      {
        route: '/feedback/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/feedback/[providerToken]/page.tsx'],
      },
      {
        route: '/feedback/status',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/feedback/status/page.tsx'],
      },
      {
        route: '/finance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/page.tsx'],
      },
      {
        route: '/finance/accommodation',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/accommodation/page.tsx'],
      },
      {
        route: '/finance/accommodation/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/accounting',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/accounting/page.tsx'],
      },
      {
        route: '/finance/an-acc',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/an-acc/page.tsx'],
      },
      {
        route: '/finance/an-acc/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/billing',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/billing/page.tsx'],
      },
      {
        route: '/finance/billing-review',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/billing-review/page.tsx'],
      },
      {
        route: '/finance/billing/readiness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/billing/readiness/page.tsx'],
      },
      {
        route: '/finance/brokerage-invoices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/brokerage-invoices/page.tsx'],
      },
      {
        route: '/finance/budgets/carry-over',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/budgets/carry-over/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/finance/charges',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/charges/page.tsx'],
      },
      {
        route: '/finance/claims',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/claims/page.tsx'],
      },
      {
        route: '/finance/claims/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/claims/[id]/page.tsx'],
      },
      {
        route: '/finance/claims/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/contributions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/contributions/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/finance/contributions/**',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/invoices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/invoices/page.tsx'],
      },
      {
        route: '/finance/invoices/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/invoices/[id]/page.tsx'],
      },
      {
        route: '/finance/invoices/*/push-to-xero',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/invoices/[id]/push-to-xero/page.tsx'],
      },
      {
        route: '/finance/natsifacp',
        classification: 'OTHER_PROGRAM',
        firewallFamilies: ['OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/natsifacp/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/finance/payers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/payers/page.tsx'],
      },
      {
        route: '/finance/payers/*/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/payers/[payerSource]/[payerId]/page.tsx',
        ],
      },
      {
        route: '/finance/rate-drift',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/rate-drift/page.tsx'],
      },
      {
        route: '/finance/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/page.tsx'],
      },
      {
        route: '/finance/reports/aged-debtors',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/aged-debtors/page.tsx'],
      },
      {
        route: '/finance/reports/ar-ageing-parity',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/ar-ageing-parity/page.tsx'],
      },
      {
        route: '/finance/reports/reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/reconciliation/page.tsx'],
      },
      {
        route: '/finance/reports/statements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/statements/page.tsx'],
      },
      {
        route: '/finance/reports/statements/dispatch',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/reports/statements/dispatch/page.tsx'],
      },
      {
        route: '/finance/reports/xero-ar-reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/reports/xero-ar-reconciliation/page.tsx',
        ],
      },
      {
        route: '/finance/residential-billing',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/residential-billing/page.tsx'],
      },
      {
        route: '/finance/residential-billing/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/respite-billing',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/respite-billing/page.tsx'],
      },
      {
        route: '/finance/respite-billing/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/finance/statements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/finance/statements/page.tsx'],
      },
      {
        route: '/finance/statements/*/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/statements/[payerKind]/[payerId]/page.tsx',
        ],
      },
      {
        route: '/finance/tac',
        classification: 'OTHER_PROGRAM',
        firewallFamilies: ['OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/finance/tac/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/forbidden',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/forbidden/page.tsx'],
      },
      {
        route: '/forgot-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/forgot-password/page.tsx'],
      },
      {
        route: '/head-office',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/page.tsx'],
      },
      {
        route: '/head-office/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/[section]/page.tsx'],
      },
      {
        route: '/head-office/agency-hours',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/agency-hours/page.tsx'],
      },
      {
        route: '/head-office/board-pack',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/board-pack/page.tsx'],
      },
      {
        route: '/head-office/facilities',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/facilities/page.tsx'],
      },
      {
        route: '/head-office/groupings',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/groupings/page.tsx'],
      },
      {
        route: '/head-office/roles',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/head-office/roles/page.tsx'],
      },
      {
        route: '/health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/health/page.tsx'],
      },
      {
        route: '/help',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/page.tsx'],
      },
      {
        route: '/help/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/[moduleGroup]/page.tsx'],
      },
      {
        route: '/help/article/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/article/[articleId]/page.tsx'],
      },
      {
        route: '/help/search',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/search/page.tsx'],
      },
      {
        route: '/help/tickets',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/tickets/page.tsx'],
      },
      {
        route: '/help/tickets/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/tickets/[ticketId]/page.tsx'],
      },
      {
        route: '/help/tickets/escalate/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/tickets/escalate/[ticketId]/page.tsx'],
      },
      {
        route: '/help/tickets/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/tickets/new/page.tsx'],
      },
      {
        route: '/help/training',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/training/page.tsx'],
      },
      {
        route: '/help/training/*',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/help/training/[lessonId]/page.tsx'],
      },
      {
        route: '/help/training/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/home-care/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/home-care/assessments',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/assessments/page.tsx'],
      },
      {
        route: '/home-care/assessments/*',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/assessments/[id]/page.tsx'],
      },
      {
        route: '/home-care/at-hm',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/at-hm/page.tsx'],
      },
      {
        route: '/home-care/budget-explainer',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/budget-explainer/page.tsx'],
      },
      {
        route: '/home-care/budgets',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/budgets/page.tsx'],
      },
      {
        route: '/home-care/care-delivery-settings',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/care-delivery-settings/page.tsx'],
      },
      {
        route: '/home-care/claims',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/claims/page.tsx'],
      },
      {
        route: '/home-care/claims/services-australia',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/claims/services-australia/page.tsx'],
      },
      {
        route: '/home-care/classifications',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/classifications/page.tsx'],
      },
      {
        route: '/home-care/exceptions',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/exceptions/page.tsx'],
      },
      {
        route: '/home-care/external-roster-import',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/external-roster-import/page.tsx'],
      },
      {
        route: '/home-care/funding-changes',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/funding-changes/page.tsx'],
      },
      {
        route: '/home-care/notes-review',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/notes-review/page.tsx'],
      },
      {
        route: '/home-care/readiness',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/readiness/page.tsx'],
      },
      {
        route: '/home-care/reconciliation',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/reconciliation/page.tsx'],
      },
      {
        route: '/home-care/schedules',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/schedules/page.tsx'],
      },
      {
        route: '/home-care/service-areas',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/service-areas/page.tsx'],
      },
      {
        route: '/home-care/service-delivery',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/service-delivery/page.tsx'],
      },
      {
        route: '/home-care/settings/apportionment',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/settings/apportionment/page.tsx'],
      },
      {
        route: '/home-care/statements',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/home-care/statements/page.tsx'],
      },
      {
        route: '/home-care/statements/*/pdf',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/home-care/statements/[statementId]/pdf/route.ts',
        ],
      },
      {
        route: '/hr/onboarding/artifacts/*/file',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/hr/onboarding/artifacts/[artifactId]/file/route.ts',
        ],
      },
      {
        route: '/impersonation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/impersonation/page.tsx'],
      },
      {
        route: '/legal/ai-disclosure',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/legal/ai-disclosure/page.tsx'],
      },
      {
        route: '/login',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/login/page.tsx'],
      },
      {
        route: '/mandatory-notifications',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/mandatory-notifications/page.tsx'],
      },
      {
        route: '/me/availability',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-AVAILABILITY',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/availability/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/availability/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/capability',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/capability/page.tsx'],
      },
      {
        route: '/me/casual-conversion',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/casual-conversion/page.tsx'],
      },
      {
        route: '/me/clinical-pin',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/clinical-pin/page.tsx'],
      },
      {
        route: '/me/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/compliance/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/compliance/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/contractor',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/page.tsx'],
      },
      {
        route: '/me/contractor/bank-account',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/bank-account/page.tsx'],
      },
      {
        route: '/me/contractor/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/compliance/page.tsx'],
      },
      {
        route: '/me/contractor/invoice',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/invoice/page.tsx'],
      },
      {
        route: '/me/contractor/invoices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/invoices/page.tsx'],
      },
      {
        route: '/me/contractor/log',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/log/page.tsx'],
      },
      {
        route: '/me/contractor/profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/profile/page.tsx'],
      },
      {
        route: '/me/contractor/shifts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/contractor/shifts/page.tsx'],
      },
      {
        route: '/me/courses/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/courses/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/courses/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/courses/*/certificate',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/me/courses/[id]/certificate/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/courses/[id]/certificate/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/courses/*/modules/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/me/courses/[id]/modules/[order]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/courses/[id]/modules/[order]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/courses/*/resume',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/courses/[id]/resume/route.ts'],
      },
      {
        route: '/me/credentials',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/credentials/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/credentials/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/delegations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/delegations/page.tsx'],
      },
      {
        route: '/me/hours',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-HOURS',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/hours/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/hours/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/leave',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-LEAVE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/leave/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/leave/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/messages',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/messages/page.tsx'],
      },
      {
        route: '/me/onboarding',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/onboarding/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/onboarding/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/onboarding/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/onboarding/artifacts/*/file',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/artifacts/[artifactId]/file/route.ts',
        ],
      },
      {
        route: '/me/onboarding/credentials',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/onboarding/credentials/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/credentials/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/onboarding/custom-form',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/onboarding/custom-form/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/custom-form/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/onboarding/financial',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/onboarding/financial/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/financial/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/onboarding/personal-details',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SELF-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/me/onboarding/personal-details/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/onboarding/personal-details/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/pay-documents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/pay-documents/page.tsx'],
      },
      {
        route: '/me/pay-documents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/pay-documents/[documentId]/page.tsx'],
      },
      {
        route: '/me/pay-documents/*/download',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/pay-documents/[documentId]/download/route.ts',
        ],
      },
      {
        route: '/me/performance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/performance/page.tsx'],
      },
      {
        route: '/me/performance/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/performance/[reviewId]/page.tsx'],
      },
      {
        route: '/me/policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/policies/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/policies/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/policies/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/policies/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/policies/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/preferences',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/preferences/page.tsx'],
      },
      {
        route: '/me/profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/profile/page.tsx'],
      },
      {
        route: '/me/renewals',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/renewals/page.tsx'],
      },
      {
        route: '/me/roster',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-ROSTER',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/roster/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/roster/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/shift-offers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-SHIFT-OFFERS',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/shift-offers/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/shift-offers/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/shift-swaps',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MY-SHIFT-SWAPS',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/shift-swaps/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/shift-swaps/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/supervision',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/supervision/page.tsx'],
      },
      {
        route: '/me/timesheets',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-TIMESHEETS',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/timesheets/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/timesheets/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/training',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/training/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/training/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/training/certificates',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/me/training/certificates/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/training/certificates/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/training/certificates/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/training/certificates/[certificateId]/route.ts',
        ],
      },
      {
        route: '/me/training/external-evidence/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/me/training/external-evidence/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/training/external-evidence/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/training/external-evidence/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/me/training/external-evidence/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/me/training/external-evidence/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/me/training/transcript',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/training/transcript/route.ts'],
      },
      {
        route: '/me/work-readiness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/me/work-readiness/page.tsx'],
      },
      {
        route: '/medications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/page.tsx'],
      },
      {
        route: '/medications/discrepancies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/discrepancies/page.tsx'],
      },
      {
        route: '/medications/exceptions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/exceptions/page.tsx'],
      },
      {
        route: '/medications/mar',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/mar/page.tsx'],
      },
      {
        route: '/medications/monitoring',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/monitoring/page.tsx'],
      },
      {
        route: '/medications/monitoring/setup',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/monitoring/setup/page.tsx'],
      },
      {
        route: '/medications/reconciliation/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/reconciliation/new/page.tsx'],
      },
      {
        route: '/medications/s8-register',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/medications/s8-register/page.tsx'],
      },
      {
        route: '/medications/s8-register/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/monitoring',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/monitoring/page.tsx'],
      },
      {
        route: '/monitoring/alerts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/monitoring/alerts/page.tsx'],
      },
      {
        route: '/monitoring/devices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/monitoring/devices/page.tsx'],
      },
      {
        route: '/monitoring/equipment',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/monitoring/equipment/page.tsx'],
      },
      {
        route: '/monitoring/vital-signs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/monitoring/vital-signs/page.tsx'],
      },
      {
        route: '/observations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/observations/page.tsx'],
      },
      {
        route: '/onboarding',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/onboarding/page.tsx'],
      },
      {
        route: '/onboarding-pipeline',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/onboarding-pipeline/page.tsx'],
      },
      {
        route: '/overview',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SETUP',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/overview/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/overview/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/pay-documents/access/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/pay-documents/access/[token]/route.ts'],
      },
      {
        route: '/payroll',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-CLOSE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll-activation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/payroll-activation/page.tsx'],
      },
      {
        route: '/payroll-switch',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/payroll-switch/page.tsx'],
      },
      {
        route: '/payroll/agency-invoices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/agency-invoices/page.tsx'],
      },
      {
        route: '/payroll/agency-invoices/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/agency-invoices/[invoiceId]/page.tsx'],
      },
      {
        route: '/payroll/corrections',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/corrections/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/corrections/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/fixed-pay',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/fixed-pay/page.tsx'],
      },
      {
        route: '/payroll/manual-closures',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/manual-closures/page.tsx'],
      },
      {
        route: '/payroll/pay-runs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/pay-runs/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/pay-documents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/pay-documents/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/pay-documents/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/provider-export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/provider-export/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/provider-export/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/push-to-xero',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/push-to-xero/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/push-to-xero/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/reconciliation/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/reconciliation/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/source-manifest',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/source-manifest/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/source-manifest/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/pay-runs/*/xero-closeout',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/xero-closeout/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/pay-runs/[id]/xero-closeout/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/policy',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-REVIEW',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/policy/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/policy/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/provider-handoff',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/provider-handoff/page.tsx'],
      },
      {
        route: '/payroll/queue',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-CLOSE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/queue/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/queue/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/readiness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-CLOSE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/payroll/readiness/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/readiness/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/payroll/reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/reconciliation/page.tsx'],
      },
      {
        route: '/payroll/reconciliation/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/reconciliation/[baselineId]/page.tsx'],
      },
      {
        route: '/payroll/reconciliation/*/staff/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/payroll/reconciliation/[baselineId]/staff/[staffId]/page.tsx',
        ],
      },
      {
        route: '/payroll/reconciliation/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/reconciliation/new/page.tsx'],
      },
      {
        route: '/payroll/setup',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/setup/page.tsx'],
      },
      {
        route: '/payroll/timesheet/*/breakdown',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/payroll/timesheet/[id]/breakdown/page.tsx'],
      },
      {
        route: '/people',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/compliance/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance/certifications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/compliance/certifications/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/certifications/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance/certifications/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/compliance/certifications/[staff_id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/certifications/[staff_id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/compliance/export/route.ts'],
      },
      {
        route: '/people/compliance/obligations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/compliance/obligations/page.tsx'],
      },
      {
        route: '/people/compliance/screening',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/compliance/screening/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/screening/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance/screening/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/compliance/screening/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/screening/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/compliance/screening/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-SCREENING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/compliance/screening/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/compliance/screening/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/conduct-decisions/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/conduct-decisions/[id]/page.tsx'],
      },
      {
        route: '/people/development',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/development/page.tsx'],
      },
      {
        route: '/people/development/casual-conversion',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/development/casual-conversion/page.tsx'],
      },
      {
        route: '/people/development/performance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/development/performance/page.tsx'],
      },
      {
        route: '/people/development/performance/*/conduct',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/development/performance/[reviewId]/conduct/page.tsx',
        ],
      },
      {
        route: '/people/development/performance/pips',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/development/performance/pips/page.tsx'],
      },
      {
        route: '/people/development/supervision',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/development/supervision/page.tsx'],
      },
      {
        route: '/people/evidence',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/evidence/page.tsx'],
      },
      {
        route: '/people/learning',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/learning/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/learning/acqsc-report',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/learning/acqsc-report/route.ts'],
      },
      {
        route: '/people/learning/analytics',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/learning/analytics/page.tsx'],
      },
      {
        route: '/people/learning/competencies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/learning/competencies/page.tsx'],
      },
      {
        route: '/people/learning/courses',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/learning/courses/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/courses/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/learning/courses/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/learning/courses/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/courses/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/learning/courses/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/learning/courses/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/courses/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/learning/external-evidence',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/learning/external-evidence/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/external-evidence/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/learning/external-evidence/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/learning/external-evidence/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/learning/external-evidence/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/offboarding',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/offboarding/page.tsx'],
      },
      {
        route: '/people/onboarding',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/onboarding/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/onboarding/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/*/credentials',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/credentials/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/credentials/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/*/custom-form/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/custom-form/[taskId]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/custom-form/[taskId]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/*/financial-details',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/financial-details/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/financial-details/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/*/personal-details',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/personal-details/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/[id]/personal-details/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/bulk-import',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/onboarding/bulk-import/page.tsx'],
      },
      {
        route: '/people/onboarding/bulk-import/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/bulk-import/[batchId]/page.tsx',
        ],
      },
      {
        route: '/people/onboarding/documents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/documents/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/documents/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/documents/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/onboarding/documents/[documentId]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/documents/[documentId]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/documents/*/file',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/documents/[documentId]/file/route.ts',
        ],
      },
      {
        route: '/people/onboarding/documents/*/signed-pdf',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/documents/[documentId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/people/onboarding/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/onboarding/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/onboarding/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/onboarding/settings',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/onboarding/settings/page.tsx'],
      },
      {
        route: '/people/policies-conduct',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/policies-conduct/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/policies-conduct/assignments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/policies-conduct/assignments/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/assignments/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/policies-conduct/cases',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/cases/page.tsx'],
      },
      {
        route: '/people/policies-conduct/code',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/code/page.tsx'],
      },
      {
        route: '/people/policies-conduct/code/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/code/[id]/page.tsx'],
      },
      {
        route: '/people/policies-conduct/code/acknowledgments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/code/acknowledgments/page.tsx',
        ],
      },
      {
        route: '/people/policies-conduct/code/allegations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/code/allegations/page.tsx',
        ],
      },
      {
        route: '/people/policies-conduct/code/analytics',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/code/analytics/page.tsx',
        ],
      },
      {
        route: '/people/policies-conduct/code/investigations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/code/investigations/page.tsx',
        ],
      },
      {
        route: '/people/policies-conduct/code/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/code/reports/page.tsx'],
      },
      {
        route: '/people/policies-conduct/code/reports/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/code/reports/export/route.ts',
        ],
      },
      {
        route: '/people/policies-conduct/governance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/governance/page.tsx'],
      },
      {
        route: '/people/policies-conduct/policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/policies-conduct/policies/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/policies/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/policies-conduct/policies/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-LEARNING-POLICIES',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/policies-conduct/policies/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/policies-conduct/policies/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/policies-conduct/publications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/policies-conduct/publications/page.tsx'],
      },
      {
        route: '/people/workers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/workers/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/workers/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/workers/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/workers/[id]/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/workers/[id]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/workers/*/administration',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/workers/[id]/administration/page.tsx'],
      },
      {
        route: '/people/workers/*/calendar',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/workers/[id]/calendar/page.tsx'],
      },
      {
        route: '/people/workers/*/pay-profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/people/workers/[id]/pay-profile/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/workers/[id]/pay-profile/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/people/workers/*/roster/printable',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/workers/[id]/roster/printable/page.tsx'],
      },
      {
        route: '/people/workers/administration',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/workers/administration/page.tsx'],
      },
      {
        route: '/people/workers/bulk-invite',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/people/workers/bulk-invite/page.tsx'],
      },
      {
        route: '/people/workers/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/people/workers/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/people/workers/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/platform-support',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/platform-support/page.tsx'],
      },
      {
        route: '/pricing/agreements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/pricing/agreements/page.tsx'],
      },
      {
        route: '/pricing/agreements/*/signed-pdf',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/pricing/agreements/[agreementId]/signed-pdf/route.ts',
        ],
      },
      {
        route: '/pricing/rate-cards',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/pricing/rate-cards/page.tsx'],
      },
      {
        route: '/pricing/rate-cards/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/programs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/programs/page.tsx'],
      },
      {
        route: '/regions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/regions/page.tsx'],
      },
      {
        route: '/regions/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/regions/[id]/page.tsx'],
      },
      {
        route: '/regions/*/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/regions/[id]/export/route.ts'],
      },
      {
        route: '/reports',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/page.tsx'],
      },
      {
        route: '/reports/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/[code]/page.tsx'],
      },
      {
        route: '/reports/generations/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/generations/[generationId]/page.tsx'],
      },
      {
        route: '/reports/sah/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/reports/sah/budgets',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/sah/budgets/page.tsx'],
      },
      {
        route: '/reports/sah/classifications',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/sah/classifications/page.tsx'],
      },
      {
        route: '/reports/subscriptions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/subscriptions/page.tsx'],
      },
      {
        route: '/reports/workforce/recalls',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/reports/workforce/recalls/page.tsx'],
      },
      {
        route: '/reset-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/reset-password/page.tsx'],
      },
      {
        route: '/residential',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/page.tsx'],
      },
      {
        route: '/residential/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/residential/activities/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/activities/[[...route]]/page.tsx'],
      },
      {
        route: '/residential/adl-events/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/adl-events/[[...route]]/page.tsx'],
      },
      {
        route: '/residential/admissions',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/admissions/page.tsx'],
      },
      {
        route: '/residential/admissions/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/admissions/[id]/page.tsx'],
      },
      {
        route: '/residential/care-minutes',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/page.tsx'],
      },
      {
        route: '/residential/care-minutes/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/[id]/page.tsx'],
      },
      {
        route: '/residential/care-minutes/an-acc',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/an-acc/page.tsx'],
      },
      {
        route: '/residential/care-minutes/an-acc/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/an-acc/[id]/page.tsx'],
      },
      {
        route: '/residential/care-minutes/daily',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/daily/page.tsx'],
      },
      {
        route: '/residential/care-minutes/daily/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/care-minutes/daily/[id]/page.tsx'],
      },
      {
        route: '/residential/community',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/community/page.tsx'],
      },
      {
        route: '/residential/daily-living',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/daily-living/page.tsx'],
      },
      {
        route: '/residential/dap-accrual',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/dap-accrual/page.tsx'],
      },
      {
        route: '/residential/evacuation-list',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/evacuation-list/page.tsx'],
      },
      {
        route: '/residential/meal-management/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/residential/meal-management/[[...route]]/page.tsx',
        ],
      },
      {
        route: '/residential/meal-management/setup',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/meal-management/setup/page.tsx'],
      },
      {
        route: '/residential/night-rounds/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/residential/night-rounds/[[...route]]/page.tsx',
        ],
      },
      {
        route: '/residential/occupancy',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/occupancy/page.tsx'],
      },
      {
        route: '/residential/occupancy/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/occupancy/[id]/page.tsx'],
      },
      {
        route: '/residential/rooms',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/rooms/page.tsx'],
      },
      {
        route: '/residential/rooms/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/rooms/[id]/page.tsx'],
      },
      {
        route: '/residential/rounds/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/rounds/[[...route]]/page.tsx'],
      },
      {
        route: '/residential/visitors/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/residential/visitors/[[...route]]/page.tsx'],
      },
      {
        route: '/roster/agency-review',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/agency-review/page.tsx'],
      },
      {
        route: '/roster/continuity',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/continuity/page.tsx'],
      },
      {
        route: '/roster/dispatch',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-DISPATCH',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/dispatch/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/dispatch/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/dispatch/print',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/page.tsx'],
      },
      {
        route: '/roster/dispatch/print/day',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/day/page.tsx'],
      },
      {
        route: '/roster/dispatch/print/handouts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/handouts/page.tsx'],
      },
      {
        route: '/roster/dispatch/print/runs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/runs/page.tsx'],
      },
      {
        route: '/roster/dispatch/print/vacancies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/vacancies/page.tsx'],
      },
      {
        route: '/roster/dispatch/print/vacancies/csv',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/vacancies/csv/route.ts'],
      },
      {
        route: '/roster/dispatch/print/wall',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/dispatch/print/wall/page.tsx'],
      },
      {
        route: '/roster/forecast',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/forecast/page.tsx'],
      },
      {
        route: '/roster/handovers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/handovers/page.tsx'],
      },
      {
        route: '/roster/health',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/**',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/health/[[...bucket]]/page.tsx'],
      },
      {
        route: '/roster/health/anacc-due',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/bsp-stale',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/missing-coordinates',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/orphaned',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/rp-expiring',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/unfunded',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/unmapped-service-types',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/health/unscheduled',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/import',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/import/page.tsx'],
      },
      {
        route: '/roster/leave',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-WORKFORCE-LEAVE',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/leave/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/leave/coverage',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-LEAVE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/leave/coverage/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/leave/coverage/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/open-shifts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/open-shifts/page.tsx'],
      },
      {
        route: '/roster/open-shifts/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/open-shifts/[id]/page.tsx'],
      },
      {
        route: '/roster/optimiser',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/optimiser/page.tsx'],
      },
      {
        route: '/roster/periods',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PERIOD-SETUP',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/periods/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/periods/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/periods/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/periods/[id]/page.tsx'],
      },
      {
        route: '/roster/periods/*/changes',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/periods/[id]/changes/page.tsx'],
      },
      {
        route: '/roster/periods/*/close',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PAYROLL-CLOSE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/periods/[id]/close/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/periods/[id]/close/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/periods/*/evidence',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/periods/[id]/evidence/page.tsx'],
      },
      {
        route: '/roster/periods/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-PERIOD-SETUP',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/periods/new/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/periods/new/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/proposals/*',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/proposals/[carePlanVersionId]/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/proposals/anacc/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/proposals/anacc/[classificationId]/page.tsx',
        ],
      },
      {
        route: '/roster/proposals/anacc/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/proposals/restrictive-practice/*',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/proposals/restrictive-practice/[rpId]/page.tsx',
        ],
      },
      {
        route: '/roster/proposals/restrictive-practice/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/roster/recalls',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/recalls/page.tsx'],
      },
      {
        route: '/roster/recalls/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/recalls/[id]/page.tsx'],
      },
      {
        route: '/roster/recalls/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/recalls/new/page.tsx'],
      },
      {
        route: '/roster/replace/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/replace/[shift_id]/page.tsx'],
      },
      {
        route: '/roster/runs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/runs/page.tsx'],
      },
      {
        route: '/roster/shift-swaps',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/shift-swaps/page.tsx'],
      },
      {
        route: '/roster/shift-swaps/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/shift-swaps/new/page.tsx'],
      },
      {
        route: '/roster/sleepover-disturbances',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/sleepover-disturbances/page.tsx'],
      },
      {
        route: '/roster/sleepover-disturbances/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/sleepover-disturbances/[id]/page.tsx'],
      },
      {
        route: '/roster/sleepover-disturbances/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/sleepover-disturbances/new/page.tsx'],
      },
      {
        route: '/roster/templates',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/templates/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/templates/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/templates/[id]/page.tsx'],
      },
      {
        route: '/roster/time-review',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-TIME-REVIEW',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/time-review/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/time-review/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/timesheets',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-TIMESHEETS',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/roster/timesheets/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/timesheets/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/timesheets/reconciliation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/timesheets/reconciliation/page.tsx'],
      },
      {
        route: '/roster/unfunded-visits',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/roster/unfunded-visits/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/roster/visit-exceptions',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/visit-exceptions/page.tsx'],
      },
      {
        route: '/roster/wing-staffing',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/roster/wing-staffing/page.tsx'],
      },
      {
        route: '/settings',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/approvals',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/approvals/page.tsx'],
      },
      {
        route: '/settings/assessments',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/assessments/page.tsx'],
      },
      {
        route: '/settings/billing',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/billing/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/cert-allowance-registry',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/cert-allowance-registry/page.tsx'],
      },
      {
        route: '/settings/cm-task-types',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/cm-task-types/page.tsx'],
      },
      {
        route: '/settings/comfort-coordination',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/comfort-coordination/page.tsx'],
      },
      {
        route: '/settings/compliance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/compliance/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/data-management',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/data-management/page.tsx'],
      },
      {
        route: '/settings/document-templates',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/document-templates/page.tsx'],
      },
      {
        route: '/settings/facilities',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-SETUP',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/settings/facilities/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/facilities/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/facility-config',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/facility-config/page.tsx'],
      },
      {
        route: '/settings/facility-config/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/settings/feature-flags',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/feature-flags/page.tsx'],
      },
      {
        route: '/settings/funding-authorisations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/funding-authorisations/page.tsx'],
      },
      {
        route: '/settings/holidays',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/holidays/page.tsx'],
      },
      {
        route: '/settings/import',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/import/page.tsx'],
      },
      {
        route: '/settings/integrations',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/integrations/dhda',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/integrations/dhda/page.tsx'],
      },
      {
        route: '/settings/integrations/hi',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/integrations/hi/page.tsx'],
      },
      {
        route: '/settings/integrations/services-australia',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/services-australia/page.tsx',
        ],
      },
      {
        route: '/settings/integrations/services-australia/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/settings/integrations/services-australia/conformance',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/services-australia/conformance/page.tsx',
        ],
      },
      {
        route: '/settings/integrations/services-australia/event-reconciliation',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/services-australia/event-reconciliation/page.tsx',
        ],
      },
      {
        route: '/settings/integrations/services-australia/mapping',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/services-australia/mapping/page.tsx',
        ],
      },
      {
        route: '/settings/integrations/xero',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/integrations/xero/page.tsx'],
      },
      {
        route: '/settings/integrations/xero/backfill',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/integrations/xero/backfill/page.tsx'],
      },
      {
        route: '/settings/integrations/xero/wizard/**',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/integrations/xero/wizard/[[...step]]/page.tsx',
        ],
      },
      {
        route: '/settings/leave-policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-LEAVE',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/settings/leave-policies/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/leave-policies/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/modules',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/modules/page.tsx'],
      },
      {
        route: '/settings/notification-audit',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notification-audit/page.tsx'],
      },
      {
        route: '/settings/notification-preferences',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notification-preferences/page.tsx'],
      },
      {
        route: '/settings/notification-routing',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notification-routing/page.tsx'],
      },
      {
        route: '/settings/notification-routing/wizard',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notification-routing/wizard/page.tsx'],
      },
      {
        route: '/settings/notifications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notifications/page.tsx'],
      },
      {
        route: '/settings/notifications/log',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/notifications/log/page.tsx'],
      },
      {
        route: '/settings/onboarding',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/page.tsx'],
      },
      {
        route: '/settings/onboarding-packs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding-packs/page.tsx'],
      },
      {
        route: '/settings/onboarding/client-packs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/client-packs/page.tsx'],
      },
      {
        route: '/settings/onboarding/consents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/consents/page.tsx'],
      },
      {
        route: '/settings/onboarding/dms-cutover',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/dms-cutover/page.tsx'],
      },
      {
        route: '/settings/onboarding/induction-policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/onboarding/induction-policies/page.tsx',
        ],
      },
      {
        route: '/settings/onboarding/readiness',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/readiness/page.tsx'],
      },
      {
        route: '/settings/onboarding/screening',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/screening/page.tsx'],
      },
      {
        route: '/settings/onboarding/worker/base',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/onboarding/worker/base/page.tsx'],
      },
      {
        route: '/settings/organisation',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/organisation/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/payroll',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/page.tsx'],
      },
      {
        route: '/settings/payroll/aba-sender',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/aba-sender/page.tsx'],
      },
      {
        route: '/settings/payroll/activation',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/activation/page.tsx'],
      },
      {
        route: '/settings/payroll/eba',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*/activate',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/activate/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/eba/*/certification',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/certification/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/eba/*/dry-run',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/dry-run/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*/export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/export/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*/manual-facts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/manual-facts/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/eba/*/rate-lines',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/rate-lines/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/eba/*/rate-schedule',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/rate-schedule/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/eba/*/rules',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/rules/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*/scope',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/scope/page.tsx'],
      },
      {
        route: '/settings/payroll/eba/*/staff',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/eba/[ebaId]/staff/page.tsx'],
      },
      {
        route: '/settings/payroll/generic-csv-earnings',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/generic-csv-earnings/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/pay-roles',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/pay-roles/page.tsx'],
      },
      {
        route: '/settings/payroll/pay-roles/prior-hours/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/pay-roles/prior-hours/[batchId]/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/pay-roles/prior-hours/*/artifacts/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/pay-roles/prior-hours/[batchId]/artifacts/[kind]/route.ts',
        ],
      },
      {
        route: '/settings/payroll/pay-roles/staff-patterns/*/artifact',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/pay-roles/staff-patterns/[evidenceId]/artifact/route.ts',
        ],
      },
      {
        route: '/settings/payroll/profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/profile/page.tsx'],
      },
      {
        route: '/settings/payroll/provider-responsibilities',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/payroll/provider-responsibilities/page.tsx',
        ],
      },
      {
        route: '/settings/payroll/worked-time-rules',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/payroll/worked-time-rules/page.tsx'],
      },
      {
        route: '/settings/people',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/people/page.tsx'],
      },
      {
        route: '/settings/people/assignment-requirements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/people/assignment-requirements/page.tsx',
        ],
      },
      {
        route: '/settings/portal',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/portal/page.tsx'],
      },
      {
        route: '/settings/registration-providers',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/registration-providers/page.tsx'],
      },
      {
        route: '/settings/retention',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/retention/page.tsx'],
      },
      {
        route: '/settings/roster',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/roster/page.tsx'],
      },
      {
        route: '/settings/security',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/security/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/service-execution',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/service-execution/page.tsx'],
      },
      {
        route: '/settings/signature-templates',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/signature-templates/page.tsx'],
      },
      {
        route: '/settings/system',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/system/page.tsx'],
      },
      {
        route: '/settings/users',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-TENANT-ADMINISTRATION',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/settings/users/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/settings/webhooks',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/webhooks/page.tsx'],
      },
      {
        route: '/settings/webhooks/*/mapping',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/webhooks/[id]/mapping/page.tsx'],
      },
      {
        route: '/settings/webhooks/docs',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/webhooks/docs/page.tsx'],
      },
      {
        route: '/settings/workflows',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/workflows/page.tsx'],
      },
      {
        route: '/settings/workflows/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/workflows/[id]/page.tsx'],
      },
      {
        route: '/settings/workflows/closeout',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/settings/workflows/closeout/page.tsx'],
      },
      {
        route: '/sign/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/sign/[token]/page.tsx'],
      },
      {
        route: '/sign/action',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/sign/action/route.ts'],
      },
      {
        route: '/signup/ci',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/signup/ci/page.tsx'],
      },
      {
        route: '/sso',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-IDENTITY-AUTHENTICATION',
        sourceFiles: ['apps/web/src/app/(auth)/sso/page.tsx'],
      },
      {
        route: '/staff/*/history-export',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/staff/[id]/history-export/page.tsx'],
      },
      {
        route: '/support-assistant-budget',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/support-assistant-budget/page.tsx'],
      },
      {
        route: '/tasks',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['apps/web/src/app/(dashboard)/tasks/page.tsx'],
      },
      {
        route: '/tasks/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['apps/web/src/app/(dashboard)/tasks/[taskId]/page.tsx'],
      },
      {
        route: '/tasks/**',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/tasks/all',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['apps/web/src/app/(dashboard)/tasks/all/page.tsx'],
      },
      {
        route: '/tasks/new',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['apps/web/src/app/(dashboard)/tasks/new/page.tsx'],
      },
      {
        route: '/tasks/service-execution-reconciliation',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/tasks/service-execution-reconciliation/page.tsx',
        ],
      },
      {
        route: '/tasks/signatures',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: ['apps/web/src/app/(dashboard)/tasks/signatures/page.tsx'],
      },
      {
        route: '/team',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/team/page.tsx'],
      },
      {
        route: '/telehealth',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/telehealth/page.tsx'],
      },
      {
        route: '/telehealth/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/telehealth/[id]/page.tsx'],
      },
      {
        route: '/telehealth/recordings',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/telehealth/recordings/page.tsx'],
      },
      {
        route: '/telehealth/schedule',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/telehealth/schedule/page.tsx'],
      },
      {
        route: '/tenant-lifecycle',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/tenant-lifecycle/page.tsx'],
      },
      {
        route: '/tenants',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/tenants/page.tsx'],
      },
      {
        route: '/tenants/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/tenants/[id]/page.tsx'],
      },
      {
        route: '/tenants/*/modules',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/tenants/[id]/modules/page.tsx'],
      },
      {
        route: '/translate',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/translate/page.tsx'],
      },
      {
        route: '/trial-activations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/trial-activations/page.tsx'],
      },
      {
        route: '/user-search',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(admin)/user-search/page.tsx'],
      },
      {
        route: '/verify/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/verify/[hash]/page.tsx'],
      },
      {
        route: '/waitlist',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/waitlist/page.tsx'],
      },
      {
        route: '/whistleblower',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/whistleblower/page.tsx'],
      },
      {
        route: '/whistleblower/follow-up',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PUBLIC-PLATFORM',
        sourceFiles: ['apps/web/src/app/whistleblower/follow-up/page.tsx'],
      },
      {
        route: '/workflows/instances',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/workflows/instances/page.tsx'],
      },
      {
        route: '/workflows/instances/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/workflows/instances/[id]/page.tsx'],
      },
      {
        route: '/workforce/availability',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/workforce/availability/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/workforce/availability/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/workforce/availability/import',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/workforce/availability/import/page.tsx'],
      },
      {
        route: '/workforce/capabilities',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-WORKFORCE-ONBOARDING',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/workforce/capabilities/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/workforce/capabilities/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/workforce/mobile-activity',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-MOBILE-ACTIVITY',
        emptyProviderSourceFile: 'apps/web/src/app/(dashboard)/workforce/mobile-activity/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/workforce/mobile-activity/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/workforce/timesheets/disputes',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        emptyProviderSemanticProofId: 'EXP-SHARED-EMPTY-PROVIDER-TIMESHEETS',
        emptyProviderSourceFile:
          'apps/web/src/app/(dashboard)/workforce/timesheets/disputes/page.tsx',
        sourceFiles: [
          'apps/web/src/app/(dashboard)/workforce/timesheets/disputes/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/wounds',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/web/src/app/(dashboard)/wounds/page.tsx'],
      },
    ],
    portal: [
      {
        route: '/',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/page.tsx'],
      },
      {
        route: '/account/delete',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/account/delete/page.tsx'],
      },
      {
        route: '/advance-care',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/advance-care/page.tsx'],
      },
      {
        route: '/api/consumer/v1/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/consumer/v1/[...segments]/route.ts'],
      },
      {
        route: '/api/portal/documents/upload',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/documents/upload/route.ts'],
      },
      {
        route: '/api/portal/feedback',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/feedback/route.ts'],
      },
      {
        route: '/api/portal/files/download',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/files/download/route.ts'],
      },
      {
        route: '/api/portal/incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/incidents/route.ts'],
      },
      {
        route: '/api/portal/legal/accept',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/api/portal/legal/accept/route.ts'],
      },
      {
        route: '/api/portal/messages',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/messages/route.ts'],
      },
      {
        route: '/api/portal/messages/attachments/download',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/client-portal/src/app/api/portal/messages/attachments/download/route.ts',
        ],
      },
      {
        route: '/api/portal/notifications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/notifications/route.ts'],
      },
      {
        route: '/api/portal/profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/profile/route.ts'],
      },
      {
        route: '/api/portal/profile/data-request',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/profile/data-request/route.ts'],
      },
      {
        route: '/api/portal/session/expiry',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/session/expiry/route.ts'],
      },
      {
        route: '/api/portal/signature-requests/link',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/signature-requests/link/route.ts'],
      },
      {
        route: '/api/portal/visits',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/portal/visits/route.ts'],
      },
      {
        route: '/api/telehealth/token',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/api/telehealth/token/route.ts'],
      },
      {
        route: '/auth/callback',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/auth/callback/route.ts'],
      },
      {
        route: '/auth/recovery',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/(auth)/auth/recovery/page.tsx'],
      },
      {
        route: '/auth/signout',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/auth/signout/route.ts'],
      },
      {
        route: '/budget',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/budget/page.tsx'],
      },
      {
        route: '/care-plan',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/care-plan/page.tsx'],
      },
      {
        route: '/care-plan/acknowledge',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/care-plan/acknowledge/page.tsx'],
      },
      {
        route: '/dashboard',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/dashboard/page.tsx'],
      },
      {
        route: '/documents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/documents/page.tsx'],
      },
      {
        route: '/feedback',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/feedback/page.tsx'],
      },
      {
        route: '/forgot-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/(auth)/forgot-password/page.tsx'],
      },
      {
        route: '/incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/incidents/page.tsx'],
      },
      {
        route: '/invoices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/client-portal/src/app/(portal)/invoices/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/login',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/(auth)/login/page.tsx'],
      },
      {
        route: '/medications',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/medications/page.tsx'],
      },
      {
        route: '/messages',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/messages/page.tsx'],
      },
      {
        route: '/my-agreement',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/my-agreement/page.tsx'],
      },
      {
        route: '/my-rights',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/my-rights/page.tsx'],
      },
      {
        route: '/portal/advance-care',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/portal/advance-care/page.tsx'],
      },
      {
        route: '/portal/attendance',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/portal/attendance/page.tsx'],
      },
      {
        route: '/privacy',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/privacy/page.tsx'],
      },
      {
        route: '/profile',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/profile/page.tsx'],
      },
      {
        route: '/reset-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-CLIENT-PORTAL-IDENTITY',
        sourceFiles: ['apps/client-portal/src/app/(auth)/reset-password/page.tsx'],
      },
      {
        route: '/restrictive-practices',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/(portal)/restrictive-practices/page.tsx'],
      },
      {
        route: '/statements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/client-portal/src/app/(portal)/statements/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/support',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/support/page.tsx'],
      },
      {
        route: '/terms',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/client-portal/src/app/terms/page.tsx'],
      },
      {
        route: '/visits',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/client-portal/src/app/(portal)/visits/page.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
    ],
    mobile: [
      {
        route: '/',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: [
          'apps/care-worker-app/app/(tabs)/index.tsx',
          'apps/care-worker-app/app/index.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/+native-intent',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/+native-intent.ts'],
      },
      {
        route: '/alerts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/alerts/index.tsx'],
      },
      {
        route: '/alerts/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/alerts/[id].tsx'],
      },
      {
        route: '/assessment',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/assessment/index.tsx'],
      },
      {
        route: '/assessment/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/assessment/[id].tsx'],
      },
      {
        route: '/assessment/run',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/assessment/run.tsx'],
      },
      {
        route: '/availability',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/availability/index.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/care-minutes',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/care-minutes/index.tsx'],
      },
      {
        route: '/care-minutes/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/care-minutes/attribution',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/care-minutes/attribution.tsx'],
      },
      {
        route: '/client/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/client/[id]/index.tsx'],
      },
      {
        route: '/client/*/comfort',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/client/[id]/comfort.tsx'],
      },
      {
        route: '/client/*/family-contacts',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/client/[id]/family-contacts.tsx'],
      },
      {
        route: '/clients',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/clients.tsx'],
      },
      {
        route: '/clock',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/clock.tsx'],
      },
      {
        route: '/cm-tasks/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/cm-tasks/new',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/cm-tasks/new.tsx'],
      },
      {
        route: '/communication/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/communication/new.tsx'],
      },
      {
        route: '/conduct',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/conduct/index.tsx'],
      },
      {
        route: '/consent/capture',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/consent/capture.tsx'],
      },
      {
        route: '/continence/new',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/care-worker-app/app/continence/new.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/development',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/development/index.tsx'],
      },
      {
        route: '/disturbance/log',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/disturbance/log.tsx'],
      },
      {
        route: '/emar',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/emar/index.tsx'],
      },
      {
        route: '/emar/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/emergency',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/emergency/index.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/escalation/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/escalation/new.tsx'],
      },
      {
        route: '/feedback/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/feedback/new.tsx'],
      },
      {
        route: '/forgot-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-IDENTITY',
        sourceFiles: ['apps/care-worker-app/app/forgot-password.tsx'],
      },
      {
        route: '/handover/client',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/care-worker-app/app/handover/client.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/handover/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/handover/new.tsx'],
      },
      {
        route: '/handover/received',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/handover/received.tsx'],
      },
      {
        route: '/help',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: [
          'apps/care-worker-app/app/help/index.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/help/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: [
          'apps/care-worker-app/app/help/[topicId].tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/incident/ipc-exposure',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/incident/ipc-exposure.tsx'],
      },
      {
        route: '/incident/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/incident/new.tsx'],
      },
      {
        route: '/incident/prevention-review',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/incident/prevention-review.tsx'],
      },
      {
        route: '/incident/quick',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/incident/quick.tsx'],
      },
      {
        route: '/incident/unified',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/incident/unified.tsx'],
      },
      {
        route: '/incident/whs',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/incident/whs.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/intake/new',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: [
          'apps/care-worker-app/app/intake/new.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/leave/**',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/leave/request',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/leave/request.tsx'],
      },
      {
        route: '/legal-notice',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-IDENTITY',
        sourceFiles: ['apps/care-worker-app/app/legal-notice.tsx'],
      },
      {
        route: '/login',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-IDENTITY',
        sourceFiles: ['apps/care-worker-app/app/login.tsx'],
      },
      {
        route: '/medication/administer',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/medication/administer.tsx'],
      },
      {
        route: '/medication/exact',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/medication/exact.tsx'],
      },
      {
        route: '/medicine-follow-up',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/medicine-follow-up.tsx'],
      },
      {
        route: '/messages',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/messages.tsx'],
      },
      {
        route: '/more',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-PROVIDER-CROSS-PROGRAM',
        sourceFiles: [
          'apps/care-worker-app/app/(tabs)/more.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/my-escalations',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/my-escalations.tsx'],
      },
      {
        route: '/my-incidents',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/my-incidents.tsx'],
      },
      {
        route: '/notes',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/notes.tsx'],
      },
      {
        route: '/notes/compose',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/notes/compose.tsx'],
      },
      {
        route: '/notification-settings',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/notification-settings.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/notifications',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/notifications.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/observation/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/observation/new.tsx'],
      },
      {
        route: '/pay-documents',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/pay-documents/index.tsx'],
      },
      {
        route: '/pay-documents/**',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/policies',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/policies/index.tsx'],
      },
      {
        route: '/policies/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/policies/[id].tsx'],
      },
      {
        route: '/profile',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/(tabs)/profile.tsx'],
      },
      {
        route: '/profile/**',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/profile/clinical-pin',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/clinical-pin.tsx'],
      },
      {
        route: '/profile/emergency-contact',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/emergency-contact.tsx'],
      },
      {
        route: '/profile/facility-devices',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/facility-devices.tsx'],
      },
      {
        route: '/profile/onboarding',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding/index.tsx'],
      },
      {
        route: '/profile/onboarding-documents',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding-documents/index.tsx'],
      },
      {
        route: '/profile/onboarding-documents/*',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding-documents/[id].tsx'],
      },
      {
        route: '/profile/onboarding/custom-form',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding/custom-form.tsx'],
      },
      {
        route: '/profile/onboarding/evidence',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding/evidence.tsx'],
      },
      {
        route: '/profile/onboarding/personal-details',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/profile/onboarding/personal-details.tsx'],
      },
      {
        route: '/recall/log',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/recall/log.tsx'],
      },
      {
        route: '/renewals',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/renewals/index.tsx'],
      },
      {
        route: '/replacements',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/replacements.tsx'],
      },
      {
        route: '/reset-password',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-IDENTITY',
        sourceFiles: ['apps/care-worker-app/app/reset-password.tsx'],
      },
      {
        route: '/resident/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/resident/adl',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/resident/adl.tsx'],
      },
      {
        route: '/resident/rounds',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/resident/rounds.tsx'],
      },
      {
        route: '/restrictive-practice/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/restrictive-practice/new.tsx'],
      },
      {
        route: '/s8-register',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/s8-register/index.tsx'],
      },
      {
        route: '/s8-register/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/safety-assessment/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/safety-assessment/new',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/safety-assessment/new.tsx'],
      },
      {
        route: '/service-execution/transport',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/service-execution/transport.tsx'],
      },
      {
        route: '/setup-pin',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-IDENTITY',
        sourceFiles: ['apps/care-worker-app/app/setup-pin.tsx'],
      },
      {
        route: '/shift/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/shift/[id].tsx'],
      },
      {
        route: '/shift/checklist',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/shift/checklist.tsx'],
      },
      {
        route: '/shift/offers',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/shift/offers.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/shift/swap-inbox',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/shift/swap-inbox.tsx'],
      },
      {
        route: '/shift/swap-request',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/shift/swap-request.tsx'],
      },
      {
        route: '/sync-queue',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/sync-queue.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/task/*',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/task/[id].tsx'],
      },
      {
        route: '/tasks',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/tasks.tsx'],
      },
      {
        route: '/timesheet',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/timesheet/index.tsx'],
      },
      {
        route: '/timesheet/**',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/timesheet/dispute',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: ['apps/care-worker-app/app/timesheet/dispute.tsx'],
      },
      {
        route: '/training',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/training/index.tsx'],
      },
      {
        route: '/training/player',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/training/player.tsx'],
      },
      {
        route: '/visit/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/visit/at-hm-request',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/visit/at-hm-request.tsx'],
      },
      {
        route: '/visit/execute',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/visit/execute.tsx'],
      },
      {
        route: '/visitors',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/(tabs)/visitors.tsx'],
      },
      {
        route: '/visitors/**',
        classification: 'RAC_ONLY',
        firewallFamilies: ['RAC'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/visits/**',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['packages/experience-contract/src/program-route-overrides.json'],
      },
      {
        route: '/visits/history',
        classification: 'SAH_ONLY',
        firewallFamilies: ['SAH'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/visits/history.tsx'],
      },
      {
        route: '/work-readiness',
        classification: 'PROGRAM_NEUTRAL',
        firewallFamilies: ['SHARED'],
        sharedSemanticProofId: 'EXP-SHARED-MOBILE-WORKER-SELF-SERVICE',
        sourceFiles: [
          'apps/care-worker-app/app/work-readiness/index.tsx',
          'packages/experience-contract/src/program-route-overrides.json',
        ],
      },
      {
        route: '/wound/new',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/wound/new.tsx'],
      },
      {
        route: '/wound/reassess',
        classification: 'CONTEXT_REQUIRED',
        firewallFamilies: ['SAH', 'RAC', 'OTHER'],
        sharedSemanticProofId: null,
        sourceFiles: ['apps/care-worker-app/app/wound/reassess.tsx'],
      },
    ],
  },
} as const;

export type GeneratedProgramClassification =
  | 'SAH_ONLY'
  | 'RAC_ONLY'
  | 'OTHER_PROGRAM'
  | 'CONTEXT_REQUIRED'
  | 'PROGRAM_NEUTRAL';

export type GeneratedProgramPolicySurface =
  keyof typeof GENERATED_PROGRAM_ROUTE_POLICY_CONTRACT.policies;

export type GeneratedProgramRoutePolicy = {
  route: string;
  classification: GeneratedProgramClassification;
  firewallFamilies: readonly string[];
  sharedSemanticProofId: string | null;
  emptyProviderSemanticProofId?: string;
  emptyProviderSourceFile?: string;
  sourceFiles: readonly string[];
};

function normalizeRoute(value: string): string {
  const pathname = value.split(/[?#]/u, 1)[0]?.replace(/\/+$/u, '') || '/';
  return pathname.startsWith('/') ? pathname : `/${pathname}`;
}

function compilePattern(pattern: string): (pathname: string) => boolean {
  if (pattern.endsWith('/**')) {
    const prefix = pattern.slice(0, -3) || '/';
    return (pathname) => pathname === prefix || pathname.startsWith(`${prefix}/`);
  }
  const expression = pattern
    .split('*')
    .map((part) => part.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&'))
    .join('[^/]+');
  const regex = new RegExp(`^${expression}$`, 'u');
  return (pathname) => regex.test(pathname);
}

// The policy table is generated and immutable, so the matcher per pattern and the
// longest-route-first order per surface are computed once instead of on every call
// (each call used to copy and sort every row and compile a RegExp per row tested).
// Both caches are bounded by the generated table; no caller input is stored.
const patternMatchers = new Map<string, (pathname: string) => boolean>();
const rowsBySurface = new Map<
  GeneratedProgramPolicySurface,
  readonly GeneratedProgramRoutePolicy[]
>();

function matchesPattern(pattern: string, pathname: string): boolean {
  let matcher = patternMatchers.get(pattern);
  if (!matcher) {
    matcher = compilePattern(pattern);
    patternMatchers.set(pattern, matcher);
  }
  return matcher(pathname);
}

function longestRouteFirst(
  surface: GeneratedProgramPolicySurface,
): readonly GeneratedProgramRoutePolicy[] {
  let rows = rowsBySurface.get(surface);
  if (!rows) {
    const policies: readonly GeneratedProgramRoutePolicy[] =
      GENERATED_PROGRAM_ROUTE_POLICY_CONTRACT.policies[surface];
    rows = [...policies].sort((left, right) => right.route.length - left.route.length);
    rowsBySurface.set(surface, rows);
  }
  return rows;
}

export function matchGeneratedProgramRoutePolicy(
  surface: GeneratedProgramPolicySurface,
  route: string,
): GeneratedProgramRoutePolicy | null {
  const pathname = normalizeRoute(route);
  return longestRouteFirst(surface).find((entry) => matchesPattern(entry.route, pathname)) ?? null;
}
